module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('GroupBase', [_c('p', {
    staticClass: "text-muted fs-6 text-center"
  }, [_vm._v("Explore and find existing groups to join.")]), _vm._v(" "), _c('SearchBox', {
    attrs: {
      "placeholder": 'Type a name or email.',
      "value": _vm.name,
      "search": _vm.fetchColleagueSearchResults
    },
    on: {
      "update:value": function($event) {
        _vm.name = $event
      }
    }
  }), _vm._v(" "), (_vm.showLoader) ? _c('Loader') : _vm._e(), _vm._v(" "), _vm._l((_vm.results), function(group) {
    return _c('GroupElement', {
      key: group.id,
      attrs: {
        "id": group.id,
        "name": group.name,
        "privacySetting": group.privacy_setting,
        "requested": group.requested,
        "isMember": group.is_member
      }
    })
  }), _vm._v(" "), (!_vm.initialState && _vm.results.length === 0) ? _c('div', [_vm._v("No search results found!")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-448d002f"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FindGroups.vue
// module id = 1019
// module chunks = 0